import React, { useState, useRef, useEffect } from 'react';
import TextField from "@mui/material/TextField";

const CustomDropdown = ({
  options = [],
  value,
  onChange,
  onInputChange,
  fetchOptions,
  getOptionLabel = (option) => option.name || '',
  getOptionValue = (option) => option.id,
  label = 'Select',
  placeholder = 'Type to search...',
  helpText = '',
  fullWidth = true,
  sx = {}
}) => {const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    const loadOptions = async () => {
      if (fetchOptions) {
        try {
          const fetchedOptions = await fetchOptions(inputValue);
          setFilteredOptions(fetchedOptions || []);
        } catch (err) {
          console.error('Error fetching options:', err);
          setFilteredOptions([]);
        }
      } else {
        const filtered = options.filter(option =>
          getOptionLabel(option).toLowerCase().includes(inputValue.toLowerCase())
        );
        setFilteredOptions(filtered);
      }
    };

    loadOptions();
  }, [inputValue, fetchOptions, options, getOptionLabel]);


  useEffect(() => {
    if (value && options.length > 0) {
      const selectedOption = options.find(option => getOptionValue(option) === value);
      if (selectedOption) {
        setInputValue(getOptionLabel(selectedOption));
      }
    } else if (!value) {
      setInputValue('');
    }
  }, [value, options, getOptionLabel, getOptionValue]);

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    setOpen(true);
    
    if (onInputChange) {
      onInputChange(newValue);
    }
  };

  const handleOptionClick = (option) => {
    setInputValue(getOptionLabel(option));
    setOpen(false);
    
    if (onChange) {
      onChange(option);
    }
  };

  const handleFocus = () => {
    setOpen(true);
  };
  const handleBlur = () => {
    setTimeout(() => setOpen(false), 150);
  };

  return (
    <div style={{ position: 'relative', width: fullWidth ? '100%' : 'auto' }}>
      <TextField
        ref={inputRef}
        type="text"
        label={label}
        value={inputValue}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        style={{
          width: '100%',
          fontSize: '14px',
          outline: 'none',
          backgroundColor: '#F8FAFC',
          ...sx
        }}
        InputProps={{
          style: {
            height: 40,
            borderRadius: '8px',
            backgroundColor: '#F8FAFC'
          }
        }}
      />      
      {open && filteredOptions.length > 0 && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1300,
            maxHeight: '200px',
            overflow: 'auto',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            marginTop: '2px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          {filteredOptions.map((option, index) => (
            <div
              key={`${getOptionValue(option)}-${index}`}
              onClick={() => handleOptionClick(option)}
              style={{
                padding: '8px 12px',
                cursor: 'pointer',
                borderBottom: index < filteredOptions.length - 1 ? '1px solid #eee' : 'none',
                backgroundColor: 'white',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f5f5f5';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
              }}
            >
              {getOptionLabel(option)}
            </div>
          ))}
        </div>
      )}
      {open && filteredOptions.length === 0 && inputValue.length > 0 && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1300,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            marginTop: '2px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            padding: '8px 12px',
            color: '#666',
          }}
        >          
        No options found for "{inputValue}"
        </div>
      )}
      {helpText && (
        <div
          style={{
            fontSize: '11px',
            color: '#888',
            marginTop: '4px',
            fontStyle: 'italic',
          }}
        >
          {helpText}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;